import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import PeriodWeeksTable from './PeriodWeeksTable';

/**
 * Always-visible Month | Period row with weeks info (i) toggle.
 */
const PeriodSummary = ({ monthLabel, periodRangeLabel, weeks, className }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const month = (monthLabel || '').trim();
  const range = (periodRangeLabel || '').trim();
  const weekRows = Array.isArray(weeks) ? weeks : [];

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  if (!month && !range) return null;

  return (
    <div
      ref={rootRef}
      className={`sales-targets-period-summary-wrap${className ? ` ${className}` : ''}`}
    >
      <div className="sales-targets-period-summary">
        {month ? (
          <div className="sales-targets-period-summary-item">
            <span className="sales-targets-period-summary-key">Month</span>
            <span className="sales-targets-period-summary-val">{month}</span>
          </div>
        ) : null}
        {month && range ? (
          <span className="sales-targets-period-summary-sep" aria-hidden>
            |
          </span>
        ) : null}
        {range ? (
          <div className="sales-targets-period-summary-item">
            <span className="sales-targets-period-summary-key">Period</span>
            <span className="sales-targets-period-summary-val">{range}</span>
          </div>
        ) : null}
        <button
          type="button"
          className={`sales-targets-weeks-info-btn${open ? ' is-open' : ''}`}
          aria-label="View period weeks"
          aria-expanded={open}
          title="Period weeks"
          onClick={() => setOpen((prev) => !prev)}
        >
          i
        </button>
      </div>

      {open && (
        <div className="sales-targets-weeks-info-panel">
          <PeriodWeeksTable
            weeks={weekRows}
            title={
              <>
                Period weeks
                {range ? ` · ${range}` : ''}
              </>
            }
          />
        </div>
      )}
    </div>
  );
};

PeriodSummary.propTypes = {
  monthLabel: PropTypes.string,
  periodRangeLabel: PropTypes.string,
  weeks: PropTypes.arrayOf(
    PropTypes.shape({
      week_start: PropTypes.string,
      week_end: PropTypes.string,
    })
  ),
  className: PropTypes.string,
};

PeriodSummary.defaultProps = {
  monthLabel: '',
  periodRangeLabel: '',
  weeks: [],
  className: '',
};

export default PeriodSummary;
